var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 4,
    fill: "#C6FB55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 19.4286V12.5714H25.1429V15.1429H20.8571V8.28571C20.8571 7.83106 20.6765 7.39502 20.355 7.07353C20.0335 6.75204 19.5975 6.57143 19.1429 6.57143H14.8571V4H8V10.8571H14.8571V8.28571H19.1429V23.7143C19.1429 24.1689 19.3235 24.605 19.645 24.9265C19.9665 25.248 20.4025 25.4286 20.8571 25.4286H25.1429V28H32V21.1429H25.1429V23.7143H20.8571V16.8571H25.1429V19.4286H32ZM13.1429 9.14286H9.71429V5.71429H13.1429V9.14286ZM26.8571 22.8571H30.2857V26.2857H26.8571V22.8571ZM26.8571 14.2857H30.2857V17.7143H26.8571V14.2857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.42d494ee3dd3ff985f6628c5e14a0925.svg";
export { ForwardRef as ReactComponent };